export const InboxPriorityOrder: PriorityHeadlineType[] = [
	"NEW",
	"NEEDS_RESPONSE",
	"WAITING_CUSTOMER",
	"UNSNOOZED",
	"UNKNOWN",
	"CLOSED",
]

export const Priority = {
	HIGH: "HIGH",
	MEDIUM: "MEDIUM",
	LOW: "LOW",
	UNKNOWN: "UNKNOWN",
} as const

export type PriorityType = keyof typeof Priority

export type PriorityHeadlineType =
	| PriorityType
	| "NEW"
	| "UNSNOOZED"
	| "NEEDS_RESPONSE"
	| "WAITING_CUSTOMER"
	| "CLOSED"

export const PriorityNaming: Record<PriorityType, string> = {
	HIGH: "Important",
	MEDIUM: "Medium",
	LOW: "Low",
	UNKNOWN: "No importance",
}

export const PriorityHeadlines: Record<PriorityHeadlineType, string> = {
	...PriorityNaming,
	UNSNOOZED: "Unsnoozed",
	NEW: "New",
	CLOSED: "Close feedback loop",
	NEEDS_RESPONSE: "Needs response",
	WAITING_CUSTOMER: "Waiting for customer",
}
